import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import axios from "axios";
import { useFormikContext } from "formik";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";

const FinalStep = (props) => {
  const [appRes, setAppRes] = useState([]);
  const { values } = useFormikContext();

  useEffect(() => {
    const fetchData = async () => {
      await axios
        .get(
          "https://apict.dag-system.com/appCreation/appinfo?appId=" +
            values.appID
        )
        .then((res) => {
          setAppRes(res.data);
        })
        .catch((err) => console.error(err));
    };
    fetchData();
    const interval = setInterval(() => {
      fetchData();
    }, 30000);
    return () => clearInterval(interval);
  }, [values.appID]);

  return (
    <div>
      <h2>La construction de votre application est en cours...</h2>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <p>
            {appRes.pendingApps > 0 ? (
              <div>
                <h3>D'autres applications sont en cours de création.</h3>
                <p>Liste d'attente: {appRes.pendingApps}</p>
                <img
                  src="https://images.squarespace-cdn.com/content/v1/5bb1dec9b10f25f1040bafb5/1539104320316-7RJNNXJUJA66VWDE15UD/ke17ZwdGBToddI8pDm48kPoswlzjSVMM-SxOp7CV59BZw-zPPgdn4jUwVcJE1ZvWQUxwkmyExglNqGp0IvTJZamWLI2zvYWH8K3-s_4yszcp2ryTI0HqTOaaUohrI8PI6FXy8c9PWtBlqAVlUS5izpdcIXDZqDYvprRqZ29Pw0o/mixedparts-queue.gif"
                  alt="gif"
                  style={{
                    width: "100%",
                  }}
                />
              </div>
            ) : (
              <div>
                {appRes.percent ? (
                  <Box display="flex" alignItems="center">
                    <Box width="100%" mr={1}>
                      <LinearProgress
                        variant="determinate"
                        value={appRes.percent}
                      />
                    </Box>
                    <Box minWidth={35}>
                      <Typography
                        variant="body2"
                        color="textSecondary">{`${Math.round(
                        appRes.percent
                      )}%`}</Typography>
                    </Box>
                  </Box>
                ) : (
                  ""
                )}
                {appRes.percent < 100 ? (
                  <h3>
                    Veuillez patienter, votre application est en cours de
                    création.
                    <img
                      style={{ marginTop: "20px", width: "90%" }}
                      src="loading.gif"
                      alt="gif"
                    />
                  </h3>
                ) : (
                  <div>
                    <h3>Votre application a été générée avec succès ! </h3>
                    <p>
                      Téléchargez-la à partir d'un smarthphone Android via ce
                      lien: <br />
                      <a href={appRes.url}>{appRes.url}</a>
                    </p>
                  </div>
                )}
              </div>
            )}
          </p>
          <Grid container justify="flex-end">
            <Box my={2}>
              <Button
                className="bottom-button"
                size="small"
                onClick={() => props.jump(1)}
                variant="outlined"
                color="primary">
                Revenir au formulaire
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default FinalStep;
